import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { selectUserIsProfessional } from 'src/app/store/selectors/user.selector';

export const professionalGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(selectUserIsProfessional).pipe(map(isProf => {
    if (isProf) {
      return router.parseUrl('/homepage');
    }
    return true;
  }));
};
